import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'helpers/Mobile';

import { UnidadService } from 'services/UnidadService';
import useRequest from '../../../hooks/useRequest';
import { useStore, useStorePersist } from "store/context";

import GradientButton from '../../../components/atoms/GradientButton';
import MainLayout from '../../../components/Layouts/MainLayout';

import SearchSelect from 'components/atoms/SearchSelect';

import Box from "components/atoms/Box";


import './styles.scss';

import {
    BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';

const ConsumoView = (props) => {
    const history = useHistory();

    const {
        beforeSubmit, afterSubmit, showSuccess, showError,
        dealWithError
    } = useRequest();

    const [{
        uf,  // La uf actual seleccionada
    }, dispatch] = useStore();

    const [{
        unidades
    }, dispatchPersist] = useStorePersist();

    const [consumos, setConsumos] = useState([]);
    const [widthChart, setWidthChart] = useState([{}]);
    const [heightChart, setHeightChart] = useState([{}]);

    const handleChange = (uf) => {
        const filtrada = unidades.find(filtrada => filtrada.unidad === uf);
        dispatch({
            type: 'setUf',
            payload: filtrada,
        });
    };

    const getUnidades = () => {
        beforeSubmit();

        UnidadService.unidades({})
            .then((unidades) => {
                afterSubmit();
                dispatchPersist({
                    type: 'setUnidades',
                    payload: unidades
                });

                if (unidades.length > 0) {

                    dispatch({
                        type: 'setUf',
                        payload: unidades[0],
                    });
                } else {
                    showError("No sé puede cargar la unidad de pagos-realizados")
                }
            }).catch((error) => {
                afterSubmit();
            });
    }

    useEffect(() => {
        if (!unidades || unidades.length === 0) {
            console.log('BUSCAR UNIDADES');
            getUnidades();
        }
        if (isMobile) {
            setWidthChart(400);
            setHeightChart(300);
        } else {
            setWidthChart(600);
            setHeightChart(300);
        }
    }, []);

    useEffect(() => {
        if (!uf) {
            return;
        }
        beforeSubmit();
        if (isMobile) {
            setWidthChart(400);
            setHeightChart(300);
        } else {
            setWidthChart(600);
            setHeightChart(300);
        }
        UnidadService.consumos(uf.id)
            .then(data => {
                afterSubmit();
                showSuccess('Consumos obtenidos');
                setConsumos(data);
                console.log("consumos obetnidos");
                console.log(data);
            }).catch((error) => {
                console.log("error no consegui");
                setConsumos([]);
                dealWithError(error, 'Error al obtener Consumos');
            });
    }, [uf]);

    const home = (e) => {
        e.preventDefault();

        history.push('/');
    };

    return (
        <MainLayout>
            {unidades && <SearchSelect onChange={handleChange} options={unidades} value={uf}></SearchSelect>}
            <div className="consumos-volver">
                <GradientButton legend={'VOLVER'} handleClick={home} />
            </div>
            <div className="consumos-box">
                {consumos.length > 0 && <Box header='TABLA COMPARATIVA DE CONSUMOS' body={
                    <BarChart
                        width={widthChart}
                        height={heightChart}
                        data={consumos}
                        margin={{
                            top: 5, right: 30, left: 20, bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="consumo" name="Consumo Actual" fill="#1F3BA3" barSize={15} />
                        <Bar dataKey="consumo_anterior" name="Consumo Anterior" fill="#0098D8" barSize={15} />
                    </BarChart>
                }>
                </Box>}
            </div>
            <div className="consumos-box">
                {consumos.length === 0 && <Box header='TABLA COMPARATIVA DE CONSUMOS' body={
                    <p>Servicio No Medido. Sin histograma de consumos</p>
                }>
                </Box>}
            </div>
        </MainLayout>
    );
}

export default withTranslation()(ConsumoView);